<template>
    <div class="w-full flex " :class="{'opacity-50' : isDragging && !isDropTargetOption }"
        @mouseenter="showInsert"
        @mouseleave="hideInsert"
    >
        <div 
            class="w-full grid grid-cols-12"
        >
            <div class="w-full border-x border-b border-gray-300 flex items-center justify-center" :style="cellStyle">
                <div class="h-10 hover:cursor-pointer w-10 flex items-center justify-center rounded-full">
                        <ArrowsUpDownSVG />
                    </div>
            </div>
            <div class="w-full col-span-1  border-x border-b border-gray-300">
                <select v-model="taskRow.task_type_id" 
                    class="px-2 py-1 w-full h-full"
                    :style="cellStyle"
                >
                    <option v-for="option in taskTypeOptions" :key="option.id" :value="option.id">
                        {{ taskRow.resolved_date ?  option.resolved_label : option.unresolved_label }}
                    </option>
                </select>
            </div>
            <div class="w-full border-r col-span-2 border-b border-gray-300">
                <input type="text" 
                    v-model="taskRow.task_label" 
                    class="px-2 py-1 w-full h-full"
                    :style="cellStyle"
                    
                />
            </div>
            <div class="w-full border-r col-span-1 border-b border-gray-300">
                <input type="date" 
                    v-model="taskRow.due_date" 
                    class="px-2 py-1 w-full h-full"
                    :class="dueDateClass"
                    
                />
            </div>
            <div class="w-full border-r col-span-1 border-b border-gray-300">
                <input type="date" 
                    v-model="taskRow.resolved_date" 
                    class="px-2 py-1 w-full h-full"
                    :style="cellStyle"
                />
            </div>
            <div class="w-full border-r border-b col-span-1 border-gray-300">
                <select v-model="taskRow.user_id" 
                    class="px-2 py-1 w-full h-full"
                    :style="cellStyle"
                >
                    <option v-for="option in userOptions" :key="option.value" :value="option.value">
                        {{ option.label }}
                    </option>
                </select>
            </div>
            <div :class="dueDateClass" class="w-full border-r flex items-center justify-center px-2 py-1 border-b col-span-1 border-gray-300">
                {{ status }}
            </div>
            <div class="w-full border-r border-b col-span-2 border-gray-300"
                    :style="cellStyle"
            >
                <textarea
                    v-model="taskRow.task_notes" 
                    class="px-2 py-1 w-full h-full overflow-hidden"
                    rows="1"
                    ref="eventNotes"
                    :style="cellStyle"
                ></textarea>
            </div>
            <div class="w-full border-r border-b col-span-2 border-gray-300"
                    :style="cellStyle"
            >
                <textarea
                    v-model="taskRow.correspondence" 
                    class="px-2 py-1 w-full h-full overflow-hidden"
                    rows="1"
                    ref="eventNotes"
                    :style="cellStyle"
                ></textarea>
            </div>
        </div>
        <div class="w-20 flex justify-center items-center px-3">
            <button class="bg-dark-secondary text-white hover:bg-dark-primary w-5 h-5 rounded-full"
                @click="removeTask"
            >
                -
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, reactive, computed, watch, onMounted, onUpdated } from 'vue';
import ArrowsUpDownSVG from '../svg-components/ArrowsUpDownSVG.vue';

const props = defineProps(['task', 'type', 'taskTypeOptions', 'userOptions', 'isDragging', 'draggingDueDate', 'draggingResolvedDate'])

const emit = defineEmits(['remove-task-row', 'update-task-row'])
const taskNotes = ref(null)

const visibleInsert = ref(false)
const insertStyle = ref('')

const taskDetails = ref(null)

const status = computed(() => {
    return taskRow.resolved_date ? "Done" : "Open"
})

const eventOrderMappingDict = ref({
    2: 0,
    3: 1,
    4: 2,
    21: 3,
    1: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    22: 9,
    9: 10,
    10: 11,
    11: 12,
    12: 13,
    13: 14,
    14: 15,
    15: 16,
    16: 17,
    17: 18,
    18: 19,
    20: 20,
    19: 21,
})


const taskRow = reactive({
    id: props.task ? props.task.id : null,
    task_type_id: props.task ? props.task.task_type ? props.task.task_type.id : null : null,
    resolved_date: props.task ? props.task.resolved_date : null,
    due_date: props.task ? props.task.due_date : null,
    user_id: props.task ? props.task.user ? props.task.user.id : null : null,
    task_notes: props.task ? props.task.task_notes : null,
    task_label: props.task ? props.task.task_label : null,
    type: props.task ? props.task.type : null,
    correspondence: props.task ? props.task.correspondence : null,
    ordinal: props.task ? props.task.ordinal : 0.00000
})

const isDropTargetOption = computed(() => {
    if(!props.task.resolved_date){
        return (props.isDragging && props.draggingDueDate == props.task.due_date) || (props.isDragging && !props.draggingDueDate && !props.task.due_date)
    } else {
        return (props.isDragging && props.draggingResolvedDate == props.task.resolved_date)
    }
})



watch(props.task, () => {
    validateRow(props.task)
    if(props.task) {
        if(props.task.task_type_id) {
            taskRow.task_type_id = props.task.task_type_id
        } else if (props.task.task_type) {
            taskRow.task_type_id = props.task.task_type.id
        }
        else {
            taskRow.task_type_id = null
        }
        if(props.task.user_id) {
            taskRow.user_id = props.task.user_id
        } else {
            if(props.task.user) {
                taskRow.user_id = props.task.user.id
            }
            else {
                taskRow.user_id = null
            }
        }
        taskRow.resolved_date = props.task.resolved_date
        taskRow.due_date = props.task.due_date
        taskRow.task_notes = props.task.task_notes
        taskRow.task_label = props.task.task_label
        taskRow.due_date = props.task.due_date
        taskRow.type = props.task.type
        taskRow.correspondence = props.task.correspondence
    } else {
        taskRow.task_type_id = null
        taskRow.resolved_date = null
        taskRow.user_id = null
        taskRow.task_notes = null
        taskRow.task_label = null
        taskRow.type = null
        taskRow.due_date = null
        taskRow.correspondence = null
        // taskRow.status = null
    }

}, {deep: true})

watch(taskRow, ()=> {
    // console.log('taskRow Watcher Fired')
    if(taskRow.task_type_id){
        taskRow.task_type = props.taskTypeOptions.filter((taskType) => taskType.id === taskRow.task_type_id)[0]
    }
    updateTask(taskRow)
})

const dueDateClass = computed(() => {
    if(status.value === 'Open'){
        return 'bg-yellow-100'
    } else if(taskRow.type == 0){
        return 'bg-[#F87171]'
    } else if(taskRow.type == 1){
        return 'bg-[#A7F3D0]'
    } else if(taskRow.type == 2){
        return 'bg-[#BAE6FD]'
    } else {
        return ''
    }
})

const defaultCellStyle = computed(() => {
    if(props.task) {
        if(props.task.type) {
            if(props.task.type == 1) {
                return 'background-color: #A7F3D0;'
            } else if(props.task.type == 3) {
                return 'background-color: #FEF3C7;'
            } else if(props.task.type == 0) {
                return 'background-color: #F87171;'
            } else {
                return 'background-color: #BAE6FD;'
            }
        }
    }
    return ''
})

const cellStyle = ref(defaultCellStyle.value)

onMounted(() => {
    validateRow(props.task)
})

function validateRow(row) {
    if(!row.task_type_id){
        // console.log('no event id')
        cellStyle.value = 'background-color: #F87171;'
        row.type = 0
    } else {
        if(row.type == 1) {
            cellStyle.value = 'background-color: #A7F3D0'
        } else {
            cellStyle.value = 'background-color: #BAE6FD;'
            row.type = 2
        }
    }
}

function showInsert() {
    visibleInsert.value = true
}

function hideInsert() {
    visibleInsert.value = false
}

function setInsertLight() {
    insertStyle.value = 'background-color: #EEF2FF;'
}

function setInsertDark() {
   insertStyle.value = 'background-color: #D1D5DB'
}

function removeTask() {
    emit('remove-task-row', taskRow.id)
}

function updateTask(rowData) {
    emit('update-task-row', rowData)
}

</script>